import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import client from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('numa_token');
    if (!token) {
      setCargando(false);
      return;
    }
    client
      .get('/auth/me')
      .then(({ data }) => setUsuario(data))
      .catch(() => localStorage.removeItem('numa_token'))
      .finally(() => setCargando(false));
  }, []);

  const guardarSesion = useCallback(({ token, usuario: u }) => {
    localStorage.setItem('numa_token', token);
    setUsuario(u);
  }, []);

  const login = useCallback(
    async (email, password) => {
      const { data } = await client.post('/auth/login', { email, password });
      guardarSesion(data);
      return data.usuario;
    },
    [guardarSesion]
  );

  const loginAdmin = useCallback(
    async (email, password) => {
      const { data } = await client.post('/auth/admin/login', { email, password });
      guardarSesion(data);
      return data.usuario;
    },
    [guardarSesion]
  );

  const registro = useCallback(
    async (datos) => {
      const { data } = await client.post('/auth/registro', datos);
      guardarSesion(data);
      return data.usuario;
    },
    [guardarSesion]
  );

  const logout = useCallback(() => {
    localStorage.removeItem('numa_token');
    setUsuario(null);
  }, []);

  const actualizarUsuario = useCallback((u) => setUsuario(u), []);

  const esStaff = usuario && ['admin', 'staff'].includes(usuario.rol);

  return (
    <AuthContext.Provider
      value={{ usuario, cargando, esStaff, login, loginAdmin, registro, logout, actualizarUsuario }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
